import type { Payment } from '../models/payment';
import { LocalStorage, PAYMENT_KEY } from '../storage';

/**
 * Backwards compatibility if payment is not encrypted.
 * Retrieves the payment details from local storage.
 */
export const getPaymentFromLocalStorage = (): Payment | undefined => {
  try {
    return LocalStorage.getEncryptedItem(PAYMENT_KEY);
  } catch (_) {
    return LocalStorage.getItem(PAYMENT_KEY) as Payment | undefined;
  }
};
